import { useState, useEffect } from 'react';
import { csAdminApi } from '../services/api';
import { useAuth } from '../context/AuthContext';

/**
 * Resolve whether the current user may perform a global (portal-wide) permission action.
 * Uses the effective permission matrix for all roles (including IT Admin and Group Secretary).
 */
export function useGlobalPermission(module, action) {
  const { user, isAuthenticated } = useAuth();
  const [allowed, setAllowed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated || !user) {
      setAllowed(false);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    csAdminApi.checkPermission({ module, action })
      .then((res) => {
        if (!cancelled) setAllowed(!!res.data?.data?.allowed);
      })
      .catch(() => {
        if (!cancelled) setAllowed(false);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [user, isAuthenticated, module, action]);

  return { allowed, loading };
}
